import React from "react";
import { Box, Typography, Container, Divider } from "@mui/material";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultFooter from "examples/Footers/DefaultFooter";
import MKBox from "components/MKBox";

const TermsAndConditions = () => {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/search-artists",
          label: "Search Artists",
          color: "info",
        }}
        md
        dark
      />

      <Box sx={{ bgcolor: "#fafafa", py: 6}}>
        <Container maxWidth="md" sx={{ mt:12}}>
          {/* Heading */}
          <Typography variant="h3" fontWeight="bold" textAlign="center" mb={3}>
            Terms & Conditions
          </Typography>

          <Typography
            variant="body2"
            textAlign="center"
            color="text.secondary"
            mb={5}
          >
            Last updated: 22 November 2025
          </Typography>

          {/* Section */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            1. Introduction
          </Typography>
          <Typography variant="body1" mb={3} sx={{ lineHeight: 1.8 }}>
            These Terms and Conditions govern your use of the MakeMyShows
            platform (“we”, “our”, “service”). By using our platform, you agree
            to be legally bound by these terms. If you do not agree, please
            discontinue the use of MakeMyShows.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Section */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            2. Definitions
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            <strong>Artist:</strong> Any performer registered on MakeMyShows
            offering services for live shows.
            <br />
            <strong>Client/User:</strong> Anyone booking an artist or contacting
            through the platform.
            <br />
            <strong>Booking Amount:</strong> Total amount payable for hiring an
            artist.
            <br />
            <strong>Platform Fee:</strong> Service fee charged by MakeMyShows
            for enabling bookings.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Section */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            3. Booking & Payments
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            To confirm a booking, a{" "}
            <strong>20% non-refundable advance payment</strong> must be made.
            The remaining{" "}
            <strong>80% must be paid before or on the event day.</strong>{" "}
            Payments may be processed through the platform or directly to the
            artist where applicable.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Section */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            4. Booking Changes & Cancellations
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            Any change in the event schedule (date, venue, timings, etc.) must
            be communicated to MakeMyShows in writing. A cancellation fee
            applies:
            <br />
            <br />• 🎟️ <strong>7+ days before event:</strong> 20% Advance
            non-refundable
            <br />• 🎟️ <strong>Less than 7 days:</strong> 50% cancellation fee
            <br />
            <br />
            Refunds are not offered for last-minute schedule mismatches caused
            by the client.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Section */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            5. Performance Requirements
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            The client must provide a safe stage environment, power supply,
            necessary permissions, and security if required. Artists reserve the
            right to decline or stop a performance if conditions are unsafe or
            disrespectful.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Section */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            6. Code of Conduct
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            All communication on the platform must be respectful. Abuse,
            harassment, or attempts to bypass the platform to contact artists
            directly may result in account suspension or legal action.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Section */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            7. Liability
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            MakeMyShows is a booking facilitator and is not responsible for
            performance outcomes, travel delays, disputes, or damages. Our
            maximum liability shall not exceed the platform fee paid.
          </Typography>

          <Divider sx={{ my: 4 }} />

          {/* Section */}
          <Typography variant="h5" fontWeight="bold" mb={2}>
            8. Governing Law
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            These terms shall be governed under Indian law. Any disputes will
            fall under the jurisdiction of courts in Mumbai, India.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography
            variant="body1"
            textAlign="center"
            mt={5}
            sx={{ fontStyle: "italic" }}
          >
            By accessing MakeMyShows, you acknowledge that you have read,
            understood, and agree to these Terms.
          </Typography>
        </Container>
      </Box>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
};

export default TermsAndConditions;
